export default {
  methods: {

    draw_Summary() {

      let title = this.canvasForms
      .append('g')
      .attr('transform', `translate(5, 5)`)

      // Title
      if(this.title.display == 'Y') {
        title
        .append('text')
        .attr('x', 0).attr('y', this.title.tSize*0.75)
        .attr('fill', this.title.tColor).attr('font-size', this.title.tSize)
        .text(this.title.name)
      }


      // Schedule
      let plan = this.schedule.plan
      let act  = this.schedule.act

      let schedule = this.canvasForms
      .append('g')
      .attr('transform', `translate(5, ${this.schedule.y})`)

      let tx = 0
      schedule
      .append('text')
      .attr('id', `ACT_NAME_${this.localId}`)
      .attr('x', tx).attr('y', 0)
      .attr('fill', this.schedule.tColor).attr('font-size', this.schedule.tSize)
      .text(act.name)

      tx += this.getNode(`#ACT_NAME_${this.localId}`) + 3
      schedule
      .append('text')
      .attr('id', `ACT_VAL_${this.localId}`)
      .attr('x', tx).attr('y', 0)
      .attr('fill', this.schedule.vColor).attr('font-size', this.schedule.vSize)
      .text(this.rawData[act.code] + this.schedule.unit)
      .call(this.event_Link, act) // event_Link

      tx += this.getNode(`#ACT_VAL_${this.localId}`) + this.schedule.space
      schedule
      .append('text')
      .attr('id', `PLAN_NAME_${this.localId}`)
      .attr('x', tx).attr('y', 0)
      .attr('fill', this.schedule.tColor).attr('font-size', this.schedule.tSize)
      .text(plan.name)

      tx += this.getNode(`#PLAN_NAME_${this.localId}`) + 3
      schedule
      .append('text')
      .attr('x', tx).attr('y', 0)
      .attr('fill', this.schedule.vColor).attr('font-size', this.schedule.vSize)
      .text(this.rawData[plan.code] + this.schedule.unit)
      .call(this.event_Link, plan) // event_Link
      


      // Box
      let summary = this.canvasForms
      .append('g')
      .attr('transform', `translate(5, ${this.box.y})`)

      summary
      .append('rect')
      .attr('x', 0).attr('y', 0)
      .attr('width', this.box.width).attr('height', this.box.height)
      .attr('rx', this.box.radius).attr('ry', this.box.radius).attr('opacity', this.box.opacity)
      .attr('fill', this.box.color.charAt(0) == '#' ? this.box.color : `url(#${this.localId}_${this.box.color})`)
      
      summary
      .append('text')
      .attr('id', `AREA_${this.localId}`)
      .attr('x', this.box.width/2).attr('y', this.box.height/2 + this.box.tSize*0.36)
      .attr('fill', this.box.tColor).attr('font-size', this.box.tSize)
      .attr('text-anchor', 'middle')
      .text(this.box.name)

 
      // Delta
      tx = this.box.width + 10

      summary
      .append('text')
      .attr('id', `PROG_${this.localId}`)
      .attr('x', tx).attr('y', this.box.height-2)
      .attr('fill', this.delta.tColor).attr('font-size', this.delta.tSize)
      .text(this.rawData.DELTA)
      .call(this.event_Link, this.delta) // event_Link

      tx += this.getNode(`#PROG_${this.localId}`)+2
      summary
      .append('text')
      .attr('id', `UNIT_${this.localId}`)
      .attr('x', tx).attr('y', this.box.height-2)
      .attr('fill', this.delta.uColor).attr('font-size', this.delta.uSize)
      .text(this.delta.unit)

      tx += this.getNode(`#UNIT_${this.localId}`)+2
      summary // Delta
      .append('path')
      .attr('transform', `translate(${tx}, ${this.box.height/2}) scale(${.7})`)
      .attr('d', this.gmx_deltaValue(this.rawData.DELTA, 'icon'))
      .attr('fill', this.gmx_deltaValue(this.rawData.DELTA))
    },

  } 
}